export const lastMileMenuItems = [
  { label: "DRS", path: "/operations/delivery/drs" },

  { label: "Pending for Delivery", path: "/operations/pickup-request" },

  { label: "Delivery Stock", path: "/operations/delivery" },

  { label: "Single Delivery Update", path: "/master/banks" },

  { label: "Bulk Delivery Update", path: "/operations/awb/update" },

  { label: "Manage Tracking Status", path: "/master/zones" }
];